import { createStyles, Theme } from '@material-ui/core'

const NotificationsSettingsStyles = (theme: Theme) => createStyles({
  notificationsPanelContainer: {
    padding: `0 ${theme.spacing(1) * 3}px 0 ${theme.spacing(1) * 3}px`,
  },
  divider: {
    margin: `${theme.spacing(1) * 1.5}px 0 ${theme.spacing(1)}px 0`,
  },
  infoIcon: {
    opacity: 0.6,
    height: theme.spacing(1) * 2.5,
    position: `relative`,
    top: theme.spacing(1) / 2,
    left: theme.spacing(1),
    '&:hover': {
      cursor: `pointer`,
      opacity: 1,
    },
  },
  paperClasses: {
    minWidth: 300,
    maxHeight: `60%`,
  },
  notificationsConfigsContainer: {
    marginBottom: theme.spacing(1) * 20,
  },
})

export default NotificationsSettingsStyles
